import { useCallback, useState } from "react";
import { CustomSearchParams } from "./CustomSearch";

function useCustomSearch({
  onChange,
  isDisabled = false,
}: CustomSearchParams) {

  const [search, setSearch] = useState("");
  const [hasErrors, setErrors] = useState(false);

  function isEmpty(): boolean {
    return search.length === 0;
  }

  function updateSearch(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.value.trim() !== "") {
      setErrors(false);
    }
    setSearch(e.target.value);
  }

  function clear() {
    setSearch("")
  }

  const submit = useCallback(() => {
    const value = search.trim();
    if (value === "") {
      setErrors(true)
    } else {
      onChange(value);
    }
  }, [search]);

  return {
    isDisabled,
    search,
    hasErrors,
    isEmpty,
    updateSearch,
    clear,
    submit,
  }
}

export default useCustomSearch;